module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page__hd"
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "page__desc"
  }, [_vm._v(_vm._s(_vm.desc))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title",
    domProps: {
      "textContent": _vm._s(_vm.cards[0])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-cells"
  }, [_c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.name),
      expression: "input.name"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "text",
      "placeholder": "在此输入事项详情"
    },
    domProps: {
      "value": (_vm.input.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.date),
      expression: "input.date"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.input.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "date", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "weui-btn-area"
  }, [_c('a', {
    staticClass: "weui-btn weui-btn_plain-primary",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("确认添加")]), _vm._v(" "), _c('a', {
    staticClass: "weui-btn weui-btn_plain-default",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.resItem
    }
  }, [_vm._v("内容重置")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title",
    domProps: {
      "textContent": _vm._s(_vm.cards[1] + _vm.items.length)
    }
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "weui-cells",
    attrs: {
      "name": "list-complete",
      "tag": "div"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-holder"
    }, [_c('v-touch', {
      staticClass: "weui-cell",
      class: {
        'swipecurrent': _vm.currentIndex === index
      },
      attrs: {
        "swipe-options": {
          direction: 'horizontal'
        },
        "tag": "div"
      },
      on: {
        "swipeleft": function($event) {
          _vm.onSwipleLeft(index)
        },
        "tap": function($event) {
          _vm.onTap(index)
        }
      }
    }, [_c('div', {
      staticClass: "weui-cell__bd"
    }, [_c('p', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__ft"
    }, [_c('p', {
      domProps: {
        "textContent": _vm._s(item.date)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "handle"
    }, [_c('v-touch', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.model.todo == 0),
        expression: "item.model.todo==0"
      }],
      staticClass: "handle-unread",
      on: {
        "tap": function($event) {
          _vm.change_itemState(item.id, 1)
        }
      }
    }, [_vm._v("标为计划")]), _vm._v(" "), _c('v-touch', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.model.todo > 0),
        expression: "item.model.todo>0"
      }],
      staticClass: "handle-unread",
      on: {
        "tap": function($event) {
          _vm.change_itemState(item.id, 0)
        }
      }
    }, [_vm._v("标为完成")]), _vm._v(" "), _c('v-touch', {
      staticClass: "handle-del",
      on: {
        "tap": function($event) {
          _vm.delItem(item.id)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "weui-cells__title",
    domProps: {
      "textContent": _vm._s(_vm.cards[2])
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-btn-area"
  }, [_c('a', {
    staticClass: "weui-btn weui-btn_warn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.delItems
    }
  }, [_vm._v("清空存储")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("事项内容")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("预计期限")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e263d43","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Note.vue
// module id = 557
// module chunks = 1